<template>
  <div class="app-aside">
    <div class="list">
      <div class="item" v-for="item, index in menuData" :key="index">
        <router-link :to="item.path" v-if="!item.hidden">{{ item.label }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      list: [
        { path: '/admin/', vlaue: '', label: '用户管理' },
        { path: '/admin/videoContorl', vlaue: '', label: '视频管理' },
        { path: '/admin/processContorl', vlaue: '', label: '心得管理' },
        { path: '/admin/pagerContorl', vlaue: '', label: '试卷管理' },
        { path: '/admin/answerContorl', vlaue: '', label: '考试记录' },
        { path: '/admin/SettingsControl', vlaue: '', label: '基础配置' },
      ],
    }
  },
  computed: {
    menuData() {
      return this.$store.state.permission.menuData;
    },
    // defaultActive() {
    //   // 设置默认选中的菜单项
    //   return this.$route.path;
    // }
  },
  mounted() {
    console.log('admin.uve:',this.menuData)
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>
.app-aside {
  width: 240px;
  height: 100%;
  background: #dddddd;
  float: left;

  .list {
    .item {
      a {
        display: block;
        height: 70px;
        line-height: 70px;
        text-align: center;
      }

      a.router-link-exact-active {
        background: #c9baf4;
      }
    }
  }
}
</style>